'use strict';
const {BIM_CANCELLATION_STATUS, REFUND_STEPS, NOTIFICATIONS_CONTENT, BIM_STATUS} = require('./constants');

const getDefaultOptions = () => {
    return {
        hasCTA: true,
        ctaStyle: 'prisma-btn-highlight',
        highlightIcon: 'odf-icon-loading',
        highlightStyle: 'od-prisma-color-informative',
    };
};

const getMerchantCancellationDescriptionKey = function(pnrInfo) {
    if (pnrInfo.refundStatus) {
        return `cancelNotificationStatus::${pnrInfo.refundStatus}`;
    } else {
        return `intermediateLayer_REFUND_Description${pnrInfo.merchant ? 'Merchant' : 'NonMerchant'}`;
    }
};

const getDescriptionTxt = function(widgetKeys, pnrInfo = {}, suffix) {
    const keyName = NOTIFICATIONS_CONTENT.BODY_WITH_MERCHANT_VARIATION.includes(pnrInfo.cancellationStatus) ?
        getMerchantCancellationDescriptionKey(pnrInfo) :
        `intermediateLayer_${pnrInfo.cancellationStatus}${suffix}_Description`;
    return widgetKeys[keyName];
};

const getCancellationKeys = (widgetKeys, pnrInfo) => {
    const suffix = Odigeo.AB.isAlternativeStatus && [BIM_STATUS.REFUND_WAITING_CONSENT,
        BIM_STATUS.RESOLVED_BY_CUSTOMER,
        BIM_STATUS.ALL_REFUND_WAITING_CONSENT,
        BIM_STATUS.ALL_RESOLVED_BY_CUSTOMER].includes(pnrInfo.cancellationStatus)
        ? '_STATUS'
        : '';
    return {
        cancelledTxt: (pnrInfo.sections.length > 1) ?
            widgetKeys.cancellationTextPlural :
            widgetKeys.cancellationTextSingular,
        highlight: widgetKeys[`intermediateLayer_${pnrInfo.cancellationStatus}${suffix}_Highlight`],
        description: getDescriptionTxt(widgetKeys, pnrInfo, suffix),
        cta: widgetKeys[`intermediateLayer_${pnrInfo.cancellationStatus}_Cta`],
    };
};


const setRefundData = (data, {refundStatus = '', refund = {}}) => {
    const firstRefundStatus = refundStatus || refund.status;
    if (firstRefundStatus) {
        data.status = `${REFUND_STEPS.indexOf(firstRefundStatus) + 1}/${REFUND_STEPS.length}`;
        data.options.ctaStyle = 'prisma-btn-default';
    } else {
        data.options.hasCTA = false;
    }
};

const getCancellationsData = function(widgetKeys, pnrInfo, ctaHandler) {
    const data = {
        ctaHandler,
        sections: pnrInfo.sections,
        keys: getCancellationKeys(widgetKeys, pnrInfo),
        options: getDefaultOptions(),
    };
    switch (pnrInfo.cancellationStatus) {
        case BIM_CANCELLATION_STATUS.MANAGED_BY_TOUCHLESS:
            data.type = 'critical';
            data.options.highlightIcon = 'odf-icon-warning';
            data.options.highlightStyle = 'od-prisma-color-warning';
            break;
        case BIM_CANCELLATION_STATUS.OPEN_TICKET_PENDING:
        case BIM_CANCELLATION_STATUS.CONTACT_AIRLINE:
        case BIM_CANCELLATION_STATUS.REFUND_WAITING_CONSENT:
            data.type = 'critical';
            data.options.highlightIcon = 'odf-icon-information';
            break;
        case BIM_CANCELLATION_STATUS.BANKRUPTCY:
        case BIM_CANCELLATION_STATUS.MANAGED_BY_ICM:
        case BIM_CANCELLATION_STATUS.MANUAL_AIRLINE_ALTERNATIVE:
            data.type = 'critical';
            data.options.hasCTA = false;
            data.options.highlightIcon = 'odf-icon-information';
            break;
        case BIM_CANCELLATION_STATUS.PENDING_CLASSIFICATION:
        case BIM_CANCELLATION_STATUS.CUSTOMER_ALTERNATIVE_REQUESTED:
            data.type = 'informative';
            data.options.hasCTA = false;
            break;
        case BIM_CANCELLATION_STATUS.REDEMPTION_PENDING:
            data.type = 'informative';
            data.options.ctaStyle = 'prisma-btn-default';
            data.status = '2/3';
            break;
        case BIM_CANCELLATION_STATUS.RESOLVED:
            data.type = 'informative';
            data.options.highlightIcon = 'odf-icon-information';
            break;
        case BIM_CANCELLATION_STATUS.RESOLVED_BY_CUSTOMER:
            data.type = 'informative';
            data.options.highlightIcon = Odigeo.AB.isAlternativeStatus ? 'odf-icon-tick-circle' : 'odf-icon-information';
            data.options.hasCTA = false;
            break;
        case BIM_CANCELLATION_STATUS.OPEN_TICKET_REJECTED:
        case BIM_CANCELLATION_STATUS.REFUND:
        case BIM_CANCELLATION_STATUS.REFUND_WITH_STATUS:
            data.type = 'informative';
            setRefundData(data, pnrInfo);
            break;
        case BIM_CANCELLATION_STATUS.REFUND_MERCHANT:
        case BIM_CANCELLATION_STATUS.REFUND_NO_MERCHANT:
            data.type = 'informative';
            data.options.hasCTA = false;
            break;
        case BIM_CANCELLATION_STATUS.OPEN_TICKET_ACCEPTED:
            data.type = 'successful';
            data.options.highlightIcon = 'odf-icon-plane-flexibility';
            data.options.highlightStyle = 'od-prisma-color-successful';
            break;
        case BIM_CANCELLATION_STATUS.CUSTOMER_ALTERNATIVE_ISSUED:
            data.type = 'successful';
            data.options.highlightIcon = 'odf-icon-tick-circle';
            data.options.highlightStyle = 'od-prisma-color-successful';
            data.options.hasCTA = false;
            break;
        case BIM_CANCELLATION_STATUS.REFUND_NOT_MANAGED_BY_EDO:
            data.type = 'critical';
            data.options.hasCTA = false;
            data.options.highlightIcon = 'odf-icon-information';
            break;
    }
    return data;
};

module.exports = {
    getCancellationsData,
};
